import { Link } from "react-router-dom";
import useSeo from "@/lib/useSeo";

const SIZES = [
  ["XS", "6", "32", "81–84", "63–66", "88–91"],
  ["S", "8", "34", "85–88", "67–70", "92–95"],
  ["M", "10", "36", "89–93", "71–75", "96–100"],
  ["L", "12", "38", "94–98", "76–80", "101–105"],
  ["XL", "14", "40", "99–104", "81–86", "106–111"],
];
const HEAD = ["Size", "UK", "EU", "Bust (cm)", "Waist (cm)", "Hips (cm)"];
const HOW = [
  ["Bust", "Measure around the fullest part of your bust, keeping the tape level under your arms."],
  ["Waist", "Measure around your natural waistline — the narrowest part of your torso."],
  ["Hips", "Stand with feet together and measure around the fullest part of your hips."],
];

export default function SizeGuide() {
  useSeo("Size Guide", "Maison Madison size guide with UK, EU and body measurements in centimetres.");
  return (
    <div data-testid="size-guide-page" className="px-5 sm:px-10 lg:px-16 py-16 sm:py-24">
      <div className="grid lg:grid-cols-12 gap-8 mb-14">
        <div className="lg:col-span-7">
          <p className="eyebrow text-[var(--mm-red)] mb-5 rise">Fit & sizing</p>
          <h1 className="font-serif-mm text-5xl sm:text-6xl lg:text-7xl leading-none rise d1">Size <em>guide</em></h1>
        </div>
        <p className="lg:col-span-4 lg:col-start-9 self-end text-sm text-[var(--mm-muted)] rise d2">Our outerwear is cut with a relaxed, sculpted fit. If you're between sizes, we recommend your usual size — or size up for layering over knitwear.</p>
      </div>
      <div className="overflow-x-auto border-t border-[var(--mm-line)]">
        <table data-testid="size-guide-table" className="w-full min-w-[560px] text-sm">
          <thead><tr>{HEAD.map((h) => <th key={h} className="eyebrow text-left py-5 pr-4 border-b border-[var(--mm-line)]">{h}</th>)}</tr></thead>
          <tbody>
            {SIZES.map((r) => (
              <tr key={r[0]} data-testid={`size-row-${r[0]}`} className="hover:bg-[var(--mm-sand)] transition-colors">
                {r.map((c, i) => <td key={i} className={`py-5 pr-4 border-b border-[var(--mm-line)] ${i === 0 ? "font-serif-mm text-2xl text-[var(--mm-red)]" : ""}`}>{c}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="grid lg:grid-cols-12 gap-10 mt-20">
        <h2 className="lg:col-span-3 font-serif-mm text-3xl sm:text-4xl">How to <em>measure</em></h2>
        <div className="lg:col-span-8 lg:col-start-5 grid sm:grid-cols-3 gap-8">
          {HOW.map(([t, d], i) => (
            <div key={t} className="border-t border-[var(--mm-line)] pt-5">
              <span className="font-serif-mm italic text-2xl text-[var(--mm-red)]">{["i.", "ii.", "iii."][i]}</span>
              <p className="eyebrow mt-3 mb-2">{t}</p>
              <p className="text-sm text-[var(--mm-muted)] leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-20 bg-[var(--mm-sand)] p-8 sm:p-12 flex flex-col sm:flex-row sm:items-center justify-between gap-6">
        <p className="font-serif-mm text-3xl">Still unsure? <em className="text-[var(--mm-red)]">We'll help you find your fit.</em></p>
        <Link to="/contact" data-testid="size-guide-contact-button" className="btn-mm">Ask us</Link>
      </div>
    </div>
  );
}
